import koLocale from 'element-ui/lib/locale/lang/ko' //引入element韩文语言包

const ko = {
  header: {
    home: '홈',
    yewu: '비즈니스',
    xiangmu: '프로젝트',
    zhuanjia: '전문가',
    xueyuan: '아카데미',
    zhaopin: '채용',
    xinwen: '뉴스',
    guanyu: '회사 소개',
    lianxi: '연락처',
    yxt: "게임 이펙트",
    yxd: "게임 애니메이션",
    djm: "3D 게임 모델링",
    yx: "게임 원화"
  },
  home: {
    mjnet: '명장 네트워크',
    art: '제작진',
    guoneiwai: '',
    kehu: '글로벌 고객사',
    cpxm: '프로젝트',
    ywhp: '비즈니스 호평',
    jpgzs: '프리미엄 스튜디오',
    mjxy: '명장 아카데미',
    hyzj: '업계 전문가',
    ywfb: '비즈니스 분포',
    yxkflc: '게임 개발 프로세스',
    jxxm: '엄선된 프로젝트',
    khpj: '고객 평가',
    xw: '뉴스',
    more: '더 보기',
    lookM: '더 보기',
    syg: '이전',
    xyg: '다음',
  },
  vovation: {
    ywfl: '비즈니스 분류',
    yzxm: '우수 작품',
  },
  project: {
    yzxm: '우수 프로젝트',
    zwgd: '더 이상 없음',
    xmbj: '프로젝트 배경',
    xmcg: '프로젝트 성과',
  },
  special: {
    jpgzs: '프리미엄 스튜디오',
    hyzj: '업계 전문가',
    cyal: '참여 사례'
  },
  college: {
    hyxz: '업계 선택',
    zyjs: '전공 소개',
    wlfz: '미래 발전 방향',
    kcap: '커리큘럼',
    sjap: '(4-5개월) 실제 일정에 따름',
    wmys: '우리의 장점',
    szjs: '교수진 소개',
    xyjs: '학원 소개',
    gszp: '회사 작품',
    xyzp: '학생 작품',
    xydt: '학원 소식',
    xxwc: 'HI，자세한 정보는 위챗 공식 계정을 확인해 주세요',
    xxew: '왼쪽 QR코드를 스캔하여 자세히 보기',
    glx: '관리 라인',
    jsx: '테크 라인',
    dxzz: '이펙트 팀장',
    dxzz_desc: '팀 이펙트 제작 및 프로세스 관리',
    zg: '책임',
    zg_desc: '인재 선발, 프로젝트 퀄리티 관리',
    zm: '아트 디렉터',
    zm_desc: '스타일 관리, 핵심 이펙트  디자인',
  },
  recruit: {
    zxns: '인재 채용',
    zpzw: '채용 포지션',
    search: '포지션 검색, 엔터로 검색',
    ly: '분야 선택',
    lyl: '분야',
    td: '팀 선택',
    tdt: '팀',
    dd: '지역 선택',
    dzd: '지역',
    cz: '작업',
    ckgd: '더 보기',

    zwxx: '직위 정보',
    zz: '직무',
    yq: '요구사항',
    sqgw: '지원하기',
    jlsc: '이력서 업로드',
    xzwj: '파일 선택',
    zcgs: '지원 형식',
    xm: '이름',
    nl: '나이',
    yx: '이메일',
    sjhm: '휴대폰 번호',
    tj: '제출',

    qname: '이름을 입력해 주세요',
    qphone: '휴대폰 번호를 입력해 주세요',
    qtruephone: '올바른 휴대폰 번호를 입력해 주세요',
    qemail: '이메일을 입력해 주세요',
    qtruemail: '올바른 이메일을 입력해 주세요',
    qage: '나이를 입력해 주세요',
  },
  new: {
    gsxw: '회사 뉴스',
    syp: '이전 글',
    xyp: '다음 글',
  },
  about: {
    qyjzg: '기업 가치관',
    fzlc: '발전 과정',
    mjtd: '명장 팀',
    gsfw: '회사 분위기',
  },
  contact: {
    hello: '안녕하세요',
    lt: '귀하의 요구사항을 경청하는 것이',
    gz: '우리의 가장 중요한 업무입니다.',
    name: '이름',
    gsmc: '회사명',
    lxfs: '연락처',
    xq: '요구사항',
    qsr: '입력해 주세요 ',
    tj: '제출',
    qxfgs: '지사',
    qtruemobile: '올바르게 입력해 주세요',
    qgs: '올바른 형식의 휴대폰 번호를 입력해 주세요',
    neirong: '내용을 완성해 주세요',

    qsrxm: '이름을 입력해 주세요',
    qsrgsmc: '회사명을 입력해 주세요',
    qsrlxfs: '연락처를 입력해 주세요',
    qsrxq: '요구사항을 입력해 주세요'
  },
  ...koLocale
}

export default ko;